import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
  tone?: 'light' | 'dark';
};
export function Countdown({
  size = 'lg',
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'horas'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  const isLarge = size === 'lg';
  const box = tone === 'dark' ? 'bg-white/5 text-ivory border-gold/40' : 'bg-white text-ink border-gold-line';
  const label = tone === 'dark' ? 'text-gold' : 'text-ink-muted';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`El precio de lanzamiento termina en ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-85" data-mp="324zx5svjzsvm">
      {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-86" data-mp="15bog021yi8hd" data-mpi={i}>
          {i > 0 && <span aria-hidden="true" className={`font-serif ${isLarge ? 'text-2xl sm:text-3xl' : 'text-lg'} ${tone === 'dark' ? 'text-gold/60' : 'text-gold'}`} data-id="element-87" data-mp="159263vrlfgvz">
              :
            </span>}
          <div className={`rounded-card border text-center tabular-nums ${box} ${isLarge ? 'min-w-[78px] px-4 py-3 sm:min-w-[104px] sm:px-7 sm:py-4' : 'min-w-[58px] px-3 py-2'}`} data-id="element-88" data-mp="17t2kkpjt03x1">
            <div className={`font-serif leading-none ${isLarge ? 'text-3xl sm:text-4xl' : 'text-lg'}`} data-id="element-89" data-mp="a498th4ity2z">
              {unit.value}
            </div>
            <div className={`mt-2 uppercase tracking-[0.24em] ${label} ${isLarge ? 'text-[10px]' : 'text-[8px]'}`} data-id="element-90" data-mp="k0vug84o8t62">
              {unit.label}
            </div>
          </div>
        </React.Fragment>)}
    </div>;
}